// extracted by mini-css-extract-plugin
export default {"mainSections":"MainSections_mainSections__Gftt3","mainRoute":"MainSections_mainRoute__B+rGo"};